'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function ProposalControlRoomRedirect() {
  const router = useRouter();
  useEffect(() => { router?.replace('/proposals'); }, [router]);
  return null;
}